import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {ChevronLeftIcon} from '@salesforce/retail-react-app/app/components/icons';
import {ensureArray} from '@amblique/king-living/app/utils/utils';
import Link from '@salesforce/retail-react-app/app/components/link';
import {
  Box, Button, Divider, Flex, Text, useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';
import {ArrowRightIcon} from '@amblique/king-living/app/components/icons';
import {Link as ContentfulLink} from '@amblique/king-living/app/contentful/models/link';

import {MenuItemContent} from '@amblique/king-living/app/components/mega-menu/shared/menu-item-container';

export const MegaMenuSubcategoryPanel = ({
  category,
  onBackClick,
  transform = 'translateX(100%)',
  zIndex = 3,
  ...props
}) => {
  const styles = useMultiStyleConfig('MegaMenu', {});

  const submenuItems = ensureArray(category?.submenuCollection?.items);

  return (
    <Box
      className="mega-menu-subcategory-panel"
      {...styles.mobileSubcategoryPanel}
      transform={transform}
      zIndex={zIndex}
      {...props}
      sx={{
        willChange: 'transform',
        ...props.sx,
      }}
    >
      <Box className="mega-menu-subcategory-panel-wrapper" {...styles.mobileSubcategoryPanelContent}>
        {onBackClick && (
          <Box {...styles.backButtonWrapper}>
            <Button
              className="mega-menu-subcategory-panel-back-button"
              data-testid="mega-menu-subcategory-panel-back-button"
              leftIcon={<ChevronLeftIcon />}
              variant="ghost"
              onClick={onBackClick}
              {...styles.backButton}
            >
              <FormattedMessage defaultMessage="Back" id="mega_menu.back_button" />
            </Button>
          </Box>
        )}
        {category?.link && (
          <Box {...styles.shopAllLinkWrapper}>
            <ContentfulLink className="shop-all-link" component={category.featuredLink}>
              <FormattedMessage defaultMessage="Shop all" id="mega_menu.shop_all_link" /> {category.title.toLowerCase()} <ArrowRightIcon />
            </ContentfulLink>
          </Box>
        )}
        <MenuItemContent
          isMobile={true}
          menuItem={category}
          submenuItems={submenuItems}
        />
      </Box>
    </Box>
  );
};

MegaMenuSubcategoryPanel.displayName = 'MegaMenuSubcategoryPanel';
MegaMenuSubcategoryPanel.propTypes = {
  category: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired,
  transform: PropTypes.string,
  zIndex: PropTypes.number,
};
